import { BaseFieldRenderer } from './base-field-renderer';
import { FieldOption, RadioFieldJsonData, RenderOptions } from '../../models/element-types';
import { TranslateUtils } from '../../utils/translate.utils';
import { HtmlUtils } from '../../utils/html.utils';

export class RadioFieldRenderer extends BaseFieldRenderer<RadioFieldJsonData> {
    protected override get defaultData(): RadioFieldJsonData {
        const option = TranslateUtils.RADIO_FIELD.OPTION;
        return {
            id: '',
            type: 'radio',
            label: TranslateUtils.RADIO_FIELD.LABEL,
            required: false,
            hiddenLabel: false,
            options: [
                { value: `${option} 1`, label: `${option} 1` },
                { value: `${option} 2`, label: `${option} 2` },
                { value: `${option} 3`, label: `${option} 3` }
            ]
        };
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    protected override renderContent(fieldJsonData: RadioFieldJsonData, options: RenderOptions = {}): HTMLElement {
        const elementContent = document.createElement('div');
        elementContent.classList.add('element-content');

        const fieldset = document.createElement('fieldset');
        fieldset.classList.add('field', 'field__radio');
        if (fieldJsonData.required) {
            fieldset.classList.add('required');
        }

        if (!fieldJsonData.hiddenLabel) {
            const legend = document.createElement('legend');
            legend.classList.add('label');
            this.applyHtmlLabel(legend, fieldJsonData.label);
            fieldset.appendChild(legend);
        }

        const optionsContainer = document.createElement('div');
        optionsContainer.classList.add('options');

        const fieldOptions = fieldJsonData.options || [];
        const fieldLabel = this.getPlainLabel(fieldJsonData.label);
        fieldOptions.forEach((option, index) => {
            const optionElement = this.createOption(option, fieldJsonData.id, index, fieldLabel);
            optionsContainer.appendChild(optionElement);
        });

        fieldset.appendChild(optionsContainer);

        const errorContainer = this.renderErrorContainer(fieldJsonData);
        fieldset.appendChild(errorContainer);

        if (fieldJsonData.showDescription) {
            const description = this.renderDescription(fieldJsonData);
            fieldset.appendChild(description);
        }

        elementContent.appendChild(fieldset);

        return elementContent;
    }

    private createOption(option: FieldOption, parentId: string, index: number, fieldLabel: string): HTMLElement {
        const optionElement = document.createElement('div');
        optionElement.classList.add('option');

        const inputId = `${parentId}_opt_${index}`;

        const input = document.createElement('input');
        input.id = inputId;
        input.type = 'radio';
        input.classList.add('input');
        input.name = parentId;
        input.value = HtmlUtils.escapeHtml(option.value);
        input.dataset['label'] = fieldLabel;

        const label = document.createElement('label');
        label.classList.add('label');
        label.setAttribute('for', inputId);
        label.innerHTML = HtmlUtils.sanitize(option.label);

        optionElement.append(input, label);

        return optionElement;
    }

    protected renderInput(): HTMLElement {
        return document.createElement('div');
    }
}
